<template>
  <div>
    <h1 class="text-center mb-3">{{ title }}</h1>
    <v-flex xs12 v-if="activeParticipantTypes.brokers">
      <PersonList
        :title="stringMapping.brokers"
        v-model="participants.brokers"
        @update-list="updateFields"
        dialogText="<p>
            Vennligst registrer alle som er til stede på vegne av megler.
          </p>"
      ></PersonList>
    </v-flex>
    <v-flex xs12 v-if="activeParticipantTypes.landlords">
      <PersonList
        :title="stringMapping.landlords"
        v-model="participants.landlords"
        @update-list="updateFields"
        dialogText="<p>
            Vennligst registrer alle som er til stede på vegne av utleier. Dette kan da være utleier selv, eller megler som da er representant for utleier av boligen
          </p>"
      ></PersonList>
    </v-flex>
    <v-flex xs12 class="mt-3" v-if="activeParticipantTypes.sellers">
      <PersonList
        :title="stringMapping.sellers"
        v-model="participants.sellers"
        @update-list="updateFields"
        dialogText="<p>
            Vennligst registrer alle som er til stede på vegne av selger. Dette kan da være selger selv, eller representant for selger av boligen
          </p>"
      ></PersonList>
    </v-flex>
    <v-flex xs12 class="mt-3" v-if="activeParticipantTypes.tenants">
      <PersonList
        :title="stringMapping.tenants"
        v-model="participants.tenants"
        @update-list="updateFields"
        dialogText="<p>
            Personer som ikke er registrert som leietager eller utleier, må ha fullmakt for å signere overtagelsesprotokollen.
          </p>
          <p>
            Fullmakt skal foreligge hos representant for utleier. Har du med deg fullmakt på overtagelsen, kan du ta et bilde av den ved å klikke på <v-icon>mdi-camera</v-icon>
          </p>"
      ></PersonList>
    </v-flex>
    <v-flex xs12 class="mt-3" v-if="activeParticipantTypes.buyers">
      <PersonList
        :title="stringMapping.buyers"
        v-model="participants.buyers"
        @update-list="updateFields"
        dialogText="<p>
            Personer som ikke er registrert som kjøper eller selger, må ha fullmakt for å signere overtagelsesprotokollen.
          </p>"
      ></PersonList>
    </v-flex>
    <ImageUploadBox :images="participants.images" title="Fullmakter:" @update-fields="updateFields"></ImageUploadBox>
    <StepButtons @next-page="next" @previous-page="previous" :step="this" />
  </div>
</template>

<script>
import step from "../../mixins/step";
import PersonList from "../form/PersonList.vue";
export default {
  mixins: [step],
  data() {
    return {
      participants: {},
      title: "Deltakere til stede",
      stringMapping: {
        brokers: "Megler(e)",
        sellers: "Selger(e)",
        buyers: "Kjøper(e)",
        landlords: "Utleier(e)",
        tenants: "Leietager(e)"
      }
    }
  },
  beforeMount() {
    this.participants = this.protocol.saved_values.participants
    for(let type in this.activeParticipantTypes) {
      if(this.participants[type] === undefined || this.participants[type] === null) {
        this.participants[type] = []
      }
    }
    if (this.config) {
      if(this.config.title) {
        this.title = this.config.title
      }
      if(this.config.stringMapping) {
        for(let map in this.config.stringMapping) {
          this.stringMapping[map] = this.config.stringMapping[map]
        }
      }
    }
  },
  components: { PersonList },
  methods: {
    next: function() {
      let phones = []
      for(let type in this.activeParticipantTypes) {
        if(this.activeParticipantTypes[type].min != null && this.activeParticipantTypes[type].min != undefined) {
          if(this.activeParticipantTypes[type].min > 0) {
            if(this.participants[type].length < this.activeParticipantTypes[type].min) {
              this.$emit(
                "error",
                "Det må være minst "+this.activeParticipantTypes[type].min+" representanter for "+this.stringMapping[type]+" tilstede."
              );
              return false;
            }
          }
        }
        if(this.activeParticipantTypes[type].max != null && this.activeParticipantTypes[type].max != undefined) {
          if(this.activeParticipantTypes[type].max < this.participants[type].length) {
            this.$emit(
                "error",
                "Det kan maks være "+this.activeParticipantTypes[type].max+" representanter for "+this.stringMapping[type]+" tilstede."
              );
              return false;
          }
        }
        for(let part in this.participants[type]) {
          if(this.participants[type][part].phone == '' || this.participants[type][part].phone == null || this.participants[type][part].phone == undefined) {
            this.$emit(
                "error",
                "Alle deltakere må ha telefonnummer: "+this.participants[type][part].firstname+' '+this.participants[type][part].lastname
              );
              return false;
          }
          if(phones.includes(this.participants[type][part].phone)) {
            this.$emit(
                "error",
                "Samme telefonnr kan kun benyttes på én deltaker: "+this.participants[type][part].phone
              );
              return false;
          }
          phones.push(this.participants[type][part].phone)
        }
      }
      this.$emit("next-page");
    }
  },
  computed: {
    activeParticipantTypes: function() {
      let participantsTypes = {}
      if(this.stepValues.activeParticipantTypes != null && this.stepValues.activeParticipantTypes != undefined) {
        for(let type in this.stepValues.activeParticipantTypes) {
          if(this.stepValues.activeParticipantTypes[type]) {
            if(this.stepValues.activeParticipantTypes[type].active) {
              participantsTypes[type] = this.stepValues.activeParticipantTypes[type]
            }
          }
        }
      }
      else {
        let pTypes = {"brokers": {"min": 0, "active": true}, "landlords": {"min": 0, "active": true}, "tenants": {"min": 1, "active": true}}
        for(let type in pTypes) {
          if(this.stepValues.activeParticipantTypes[type]) {
            if(this.stepValues.activeParticipantTypes[type].active) {
              participantsTypes[type] = this.stepValues.activeParticipantTypes[type]
            }
          }
        }
      }
      return participantsTypes
    }
  }
};
</script>
